import Analytics from "analytics/util/Analytics";

export const PROMO_IDS = {
	LOGIN_TAKEOVER: "alist.logintakeover",
	DESKTOP_NAVBAR: "alist.desktopnavbar",
	PROFILE_MENU: "alist.profile_menu",
	SELF_PROFILE: "alist.self_profile",
};


function getAnalyticsProps(promoId, additionalCost) {
	return {
		data: {
			"has alist basic": true,
			feature: "alist premium",
			promoid: promoId,
			"price difference": additionalCost,
			"rate card version": "2.0",
		},
	};
}

export function viewedFirstPartyPromoEvent(promoId, additionalCost) {
	Analytics.logUIEvent(Analytics.eventNames.viewedFirstPartyPromo,
		getAnalyticsProps(promoId, additionalCost),
	);
}

export function viewedRateCardEvent(promoId, additionalCost) {
	Analytics.logUIEvent(Analytics.eventNames.viewedRateCard,
		getAnalyticsProps(promoId, additionalCost),
	);
}

export function selectedFirstPartyPromoEvent(promoId, additionalCost) {
	Analytics.logUIEvent(Analytics.eventNames.selectedFirstPartyPromo,
		getAnalyticsProps(promoId, additionalCost),
	);
}



// WEBPACK FOOTER //
// ./src/shared/components/AListPremiumUpgradeRateCard/analytics.js